(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["led-downlights-keuzehulp"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.ledDownlightsFacetLinksReady) return;
    window.ledDownlightsFacetLinksReady = true;

    const routeSelector = '[data-led-downlights-facet-target]';
    const scrollOptions = () => ({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'center',
    });
    const findFacet = (container, formSelector, key) =>
      Array.from(container.querySelectorAll(`${formSelector} .js-filter[data-facet-key]`)).find(
        (details) => details.dataset.facetKey === key
      );
    const openDesktopFilter = (root, key) => {
      const details = findFacet(root, '#FacetFiltersForm', key);
      if (!details) return false;
      details.open = true;
      details.scrollIntoView(scrollOptions());
      window.setTimeout(() => details.querySelector(':scope > summary')?.focus({ preventScroll: true }), 0);
      return true;
    };
    const openMobileFilter = (root, key) => {
      const drawer = root.querySelector('menu-drawer.mobile-facets__wrapper');
      const outerDetails = drawer?.querySelector(':scope > details.mobile-facets__disclosure');
      const outerSummary = outerDetails?.querySelector(':scope > summary');
      if (!drawer || !outerDetails || !outerSummary) return false;
      const wasOpen = outerDetails.open;
      outerDetails.scrollIntoView(scrollOptions());
      if (!wasOpen) outerSummary.click();
      window.setTimeout(() => {
        const details = findFacet(drawer, '#FacetFiltersFormMobile', key);
        const summary = details?.querySelector(':scope > summary');
        if (!details || !summary) return;
        if (!details.open) summary.click();
        window.setTimeout(() => {
          details.scrollIntoView(scrollOptions());
          summary.focus({ preventScroll: true });
        }, 0);
      }, wasOpen ? 0 : 150);
      return true;
    };

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const route = event.target.closest(routeSelector);
      if (!route) return;
      const key = route.dataset.ledDownlightsFacetTarget;
      const root = document.getElementById('main-collection-filters');
      if (!key || !root) return;
      const isMobile = window.matchMedia('(max-width: 767px)').matches;
      const opened = isMobile ? openMobileFilter(root, key) : openDesktopFilter(root, key);
      if (opened) event.preventDefault();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["led-inbouwspots-keuzehulp"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.ledInbouwspotsFacetLinksReady) return;
    window.ledInbouwspotsFacetLinksReady = true;

    const routeSelector = '[data-led-inbouwspots-facet-target]';
    const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const scrollOptions = () => ({
      behavior: reduceMotion() ? 'auto' : 'smooth',
      block: 'center',
    });

    const findFacet = (container, formSelector, key) =>
      Array.from(container.querySelectorAll(`${formSelector} .js-filter[data-facet-key]`)).find(
        (details) => details.dataset.facetKey === key
      );

    const focusSummary = (details) => {
      const summary = details.querySelector(':scope > summary');
      if (summary) summary.focus({ preventScroll: true });
    };

    const openDesktopFilter = (key, root) => {
      const details = findFacet(root, '#FacetFiltersForm', key);
      if (!details) return false;

      details.open = true;
      details.scrollIntoView(scrollOptions());
      window.setTimeout(() => focusSummary(details), 0);
      return true;
    };

    const openMobileFilter = (key, root) => {
      const drawer = root.querySelector('menu-drawer.mobile-facets__wrapper');
      const outerDetails = drawer?.querySelector(':scope > details.mobile-facets__disclosure');
      const outerSummary = outerDetails?.querySelector(':scope > summary');
      if (!drawer || !outerDetails || !outerSummary) return false;

      const wasOpen = outerDetails.open;
      outerDetails.scrollIntoView(scrollOptions());
      if (!wasOpen) outerSummary.click();

      window.setTimeout(() => {
        const details = findFacet(drawer, '#FacetFiltersFormMobile', key);
        const summary = details?.querySelector(':scope > summary');
        if (!details || !summary) return;

        if (!details.open) summary.click();

        window.setTimeout(() => {
          details.scrollIntoView(scrollOptions());
          focusSummary(details);
        }, 0);
      }, wasOpen ? 0 : 150);

      return true;
    };

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;

      const route = event.target.closest(routeSelector);
      if (!route) return;

      const key = route.dataset.ledInbouwspotsFacetTarget;
      const root = document.getElementById('main-collection-filters');
      if (!key || !root) return;

      const isMobile = window.matchMedia('(max-width: 767px)').matches;
      const opened = isMobile ? openMobileFilter(key, root) : openDesktopFilter(key, root);

      if (opened) event.preventDefault();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["led-lichtlijnen-keuzehulp"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.outledLightlineChoiceReady) return;
    window.outledLightlineChoiceReady = true;
    let selectedAngle = 'all';
    let refreshScheduled = false;

    const refresh = () => {
      const choice = document.querySelector('[data-lightline-choice]');
      const grid = document.getElementById('product-grid');
      if (!choice || !grid) return;

      let visible = 0;
      const products = grid.querySelectorAll(':scope > li[data-lightline-angle]');
      products.forEach((product) => {
        const matches = selectedAngle === 'all' || product.dataset.lightlineAngle === selectedAngle;
        product.hidden = !matches;
        if (matches) visible += 1;
      });

      choice.querySelectorAll('[data-lightline-select]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.lightlineSelect === selectedAngle));
      });
      const status = choice.querySelector('[data-lightline-status]');
      if (status) {
        status.textContent = selectedAngle === 'all'
          ? `${visible} modules zichtbaar.`
          : `${visible} modules met een bundelhoek van ${selectedAngle}° zichtbaar.`;
      }
    };

    const scheduleRefresh = () => {
      if (refreshScheduled) return;
      refreshScheduled = true;
      requestAnimationFrame(() => {
        refreshScheduled = false;
        refresh();
      });
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-lightline-select]');
      if (!button || !button.closest('[data-lightline-choice]')) return;
      selectedAngle = button.dataset.lightlineSelect;
      refresh();
      document.getElementById('product-grid')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    document.addEventListener('shopify:section:load', scheduleRefresh);
    const start = () => {
      refresh();
      new MutationObserver((changes) => {
        const grid = document.getElementById('product-grid');
        if (!grid) return;
        const changedGrid = changes.some((change) =>
          change.target === grid ||
          Array.from(change.addedNodes).some((node) =>
            node.nodeType === 1 && (node.id === 'product-grid' || node.querySelector?.('#product-grid'))
          )
        );
        if (changedGrid) scheduleRefresh();
      }).observe(document.body, { childList: true, subtree: true });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["led-tl-armatuur-keuzehulp"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.ledTlArmatuurFacetLinksReady) return;
    window.ledTlArmatuurFacetLinksReady = true;

    const routeSelector = '[data-led-tl-facet-target]';
    const scrollOptions = () => ({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'center',
    });
    const findFacet = (container, formSelector, key) => {
      const facets = Array.from(container.querySelectorAll(`${formSelector} .js-filter`));
      const keys = key === 'lichtkleur' ? ['lichtkleur', 'lichkleur'] : [key];
      return facets.find((details) => keys.includes(details.dataset.facetKey)) ||
        (key === 'lichtkleur' ? facets.find((details) => {
          const label = details.querySelector(':scope > summary')?.textContent?.trim().toLowerCase() || '';
          return label.startsWith('lichtkleur') || label.startsWith('lichkleur');
        }) : null);
    };
    const openDesktopFilter = (root, key) => {
      const details = findFacet(root, '#FacetFiltersForm', key);
      if (!details) return false;
      details.open = true;
      details.scrollIntoView(scrollOptions());
      window.setTimeout(() => details.querySelector(':scope > summary')?.focus({ preventScroll: true }), 0);
      return true;
    };
    const openMobileFilter = (root, key) => {
      const drawer = root.querySelector('menu-drawer.mobile-facets__wrapper');
      const details = drawer && findFacet(drawer, '#FacetFiltersFormMobile', key);
      const outerDetails = drawer?.querySelector(':scope > details.mobile-facets__disclosure');
      const outerSummary = outerDetails?.querySelector(':scope > summary');
      if (!details || !outerDetails || !outerSummary) return false;
      const wasOpen = outerDetails.open;
      outerDetails.scrollIntoView(scrollOptions());
      if (!wasOpen) outerSummary.click();
      window.setTimeout(() => {
        const summary = details.querySelector(':scope > summary');
        if (!summary) return;
        if (!details.open) summary.click();
        window.setTimeout(() => {
          details.scrollIntoView(scrollOptions());
          summary.focus({ preventScroll: true });
        }, 0);
      }, wasOpen ? 0 : 150);
      return true;
    };

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const route = event.target.closest(routeSelector);
      if (!route || !route.closest('.led-tl-armatuur-keuzehulp')) return;
      const key = route.dataset.ledTlFacetTarget;
      const root = document.getElementById('main-collection-filters');
      if (!key || !root) return;
      const isMobile = window.matchMedia('(max-width: 767px)').matches;
      const opened = isMobile ? openMobileFilter(root, key) : openDesktopFilter(root, key);
      if (opened) event.preventDefault();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mini-spots-keuzehulp"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.miniSpotsFacetLinksReady) return;
    window.miniSpotsFacetLinksReady = true;

    const routeSelector = '[data-mini-spots-facet-target]';
    const scrollOptions = () => ({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'center',
    });
    const findFacet = (container, formSelector, key) =>
      Array.from(container.querySelectorAll(`${formSelector} .js-filter[data-facet-key]`)).find(
        (details) => details.dataset.facetKey === key
      );
    const openDesktopFilter = (root, key) => {
      const details = findFacet(root, '#FacetFiltersForm', key);
      if (!details) return false;
      details.open = true;
      details.scrollIntoView(scrollOptions());
      window.setTimeout(() => details.querySelector(':scope > summary')?.focus({ preventScroll: true }), 0);
      return true;
    };
    const openMobileFilter = (root, key) => {
      const drawer = root.querySelector('menu-drawer.mobile-facets__wrapper');
      const outerDetails = drawer?.querySelector(':scope > details.mobile-facets__disclosure');
      const outerSummary = outerDetails?.querySelector(':scope > summary');
      if (!drawer || !outerDetails || !outerSummary) return false;
      const wasOpen = outerDetails.open;
      outerDetails.scrollIntoView(scrollOptions());
      if (!wasOpen) outerSummary.click();
      window.setTimeout(() => {
        const details = findFacet(drawer, '#FacetFiltersFormMobile', key);
        const summary = details?.querySelector(':scope > summary');
        if (!details || !summary) return;
        if (!details.open) summary.click();
        window.setTimeout(() => {
          details.scrollIntoView(scrollOptions());
          summary.focus({ preventScroll: true });
        }, 0);
      }, wasOpen ? 0 : 150);
      return true;
    };

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const route = event.target.closest(routeSelector);
      if (!route) return;
      const key = route.dataset.miniSpotsFacetTarget;
      const root = document.getElementById('main-collection-filters');
      if (!key || !root) return;
      const isMobile = window.matchMedia('(max-width: 767px)').matches;
      const opened = isMobile ? openMobileFilter(root, key) : openDesktopFilter(root, key);
      if (opened) event.preventDefault();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
